import { Spacing } from "themes/interfaces";

export default {
  xxs: 0.5, // 4px
  xs: 1, // 8px
  sm: 1.5, // 12px
  md: 2, // 16px
  lg: 3, // 24px
  xl: 4, // 32px
  xxl: 6, // 48px
  xxxl: 8, // 64px
  factor: 8,
  default: 32,
} as Spacing;
